import React, { Fragment, useContext, useEffect, useState } from "react";
import SocketContext from "../../../../context/SocketContext";

export default function Bid(props) {
  const symbol_id = props.symbol_id;
  const socket = useContext(SocketContext);

  const [bid, setBid] = useState(0);

  useEffect(() => {
    socket.emit("giverate", symbol_id);
    socket.on("trade" + symbol_id, trade);
    return () => {
      socket.off("trade" + symbol_id, trade);
    };
  }, []);

  const trade = (data) => {
    if (data != null) {
      if (Bid !== data.Bid) {
        setBid(data.Bid);
      }
    }
  };

  return (
    <Fragment>
      <div className="bid">BID</div>
      <div className="bidprice">
        {props.usdInr ? "$" : null}
        {props.usdInr ? parseFloat(bid).toFixed(3) : bid}
      </div>
    </Fragment>
  );
}
